import { AtlasRegionDTO } from '@/types/atlas/AtlasRegionDTO';
import { Grid } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import React, { FC } from 'react';
import RegionsList from '@/components/help/departments/RegionsList';

interface OutletProps {
  regions?: AtlasRegionDTO[];
  handleChangeRegion: (region: AtlasRegionDTO | null) => void;
}

export const TabRegionsList: FC = () => {
  const { handleChangeRegion, regions } = useOutletContext<OutletProps>();

  return (
    <Grid container={true} columnSpacing={3}>
      <Grid item={true} xs={6}>
        <RegionsList
          handleChangeRegion={handleChangeRegion}
          regions={regions}
          indexTo={regions && regions.length / 2}
        />
      </Grid>
      <Grid item={true} xs={6}>
        <RegionsList
          handleChangeRegion={handleChangeRegion}
          regions={regions}
          indexFrom={regions && regions.length / 2}
        />
      </Grid>
    </Grid>
  );
};
